import { render, staticRenderFns } from "./VDashboardIntroduction.vue?vue&type=template&id=1bd24893&scoped=true&"
import script from "./VDashboardIntroduction.vue?vue&type=script&lang=js&"
export * from "./VDashboardIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./VDashboardIntroduction.vue?vue&type=style&index=0&id=1bd24893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd24893",
  null
  
)

export default component.exports